import React from 'react';

import useTranslation from '../../hooks/useTranslation';
import AccountList, { AccountListProps } from './AccountList';

import './AccountListInvalid.scss';

const AccountListInvalid = ({ error, retry, accounts, showNegativeAmount }: Omit<AccountListProps, 'onClick'>) => {
    const { unavailableAccountsTitle } = useTranslation();

    if (accounts?.length === 0 && !error) return null;

    return (
        <div className="invalid-list-wrapper">
            <span className="inactive-header">{unavailableAccountsTitle}</span>
            <div className="account-list">
                <AccountList
                    error={error}
                    retry={retry}
                    accounts={accounts}
                    inactive
                    onClick={() => {}}
                    showNegativeAmount={showNegativeAmount}
                />
            </div>
        </div>
    );
};

export default AccountListInvalid;
